import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { TEXT } from '../../theme/tokens'

/**
 * Shown in place of a page the signed-in user has no role for. Names the
 * groups that grant access, so the user knows what to ask for.
 */
const NotAuthorised = ({ roles }) => (
    <Box sx={{ py: 10, textAlign: 'center' }}>
        <Typography variant="overline" sx={{ color: TEXT.muted }}>
            No access
        </Typography>
        <Typography variant="h5" sx={{ color: TEXT.primary, mb: 1 }}>
            You don&apos;t have access to this page
        </Typography>
        <Typography
            variant="body2"
            sx={{ color: TEXT.secondary, mb: 3, overflowWrap: 'anywhere' }}
        >
            Ask an admin to add you to one of these groups: {roles.join(', ')}.
        </Typography>
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 1.5,
            }}
        >
            <Button component={RouterLink} to="/" variant="contained">
                Go to Home
            </Button>
            {/* Open to everyone signed in: a user with no group otherwise
                only goes round from Home to this page. */}
            <Button component={RouterLink} to="/guide" variant="outlined">
                Read the Guide
            </Button>
        </Box>
    </Box>
)

NotAuthorised.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default NotAuthorised
